export default __webpack_public_path__ + "static/portrait-25d393263dff71aef01a4036f3fe3394.jpg";